import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHeadingIconVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={27} fill="none" {...props}>
    <path fill="#B2B2B2" d="M0 5.375h16.25v16.25H0zM19.5 10.25l4.875-4.875H26v16.25h-1.625L19.5 16.75z" />
  </svg>
);
export default SvgHeadingIconVideo;
